module.exports = require("npm:masonry-layout@4.1.1/masonry.js");